import { autoinject, computedFrom } from 'aurelia-framework';
import { AuthService } from 'aurelia-authentication';
import { CurrentUser } from '../entities/current-user';

@autoinject
export class AccountService {
    setAuthResponse(token) {
		this.currentUser = new CurrentUser();
		let parsedToken = this.parseJwt(token);
		Object.assign(this.currentUser, parsedToken);
	}

	@computedFrom('currentUser.UserName')
	get currentUserName() {
		if (this.currentUser) return this.currentUser.userName;
		else return "";
	}

	currentUser: CurrentUser = new CurrentUser();
	constructor(private authService: AuthService,
	) {
	}

	parseJwt(token) {
		let base64Url = token.split('.')[1];
		let base64 = base64Url.replace('-', '+').replace('_', '/');
		return JSON.parse(window.atob(base64));
	}
	setCurrentUser() {
		let parsedToken = this.parseJwt(this.authService.getAccessToken());
		this.currentUser = new CurrentUser();
		Object.assign(this.currentUser, parsedToken);
	}
}